import _taggedTemplateLiteral from "/home/jenkins/workspace/terra.b2c.webui.register_staging/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

function _templateObject7() {
  var data = _taggedTemplateLiteral(["\n        box-sizing: border-box;\n        display: flex;\n        flex-wrap: wrap;\n        justify-content: center;\n        align-items: center;\n        font-family: 'Montserrat';\n        opacity: 0;\n        z-index: 2;\n        font-size: ", ";\n        line-height: ", ";\n        font-weight: ", ";\n        padding: ", ";\n        color: ", ";\n        background-color: ", ";\n        transition: ", ";\n        z-index: ", ";\n        width: 100%;\n        overflow: hidden;\n\n        ", "\n\n        ", "\n    "]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n    ", "\n"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n    position: relative;\n\n    ", "\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n    position: fixed;\n    left: 0;\n    top: -100vh;\n    ", "\n\n    ", "\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n        font-size: ", ";\n        width: calc(100% - 2 * ", ");\n        margin: ", " ", ";\n    "]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n    ", "\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n    ", "\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import styled, { css } from 'styled-components';
import { media } from 'styled-bootstrap-grid';
import { Icon } from '../Icon';
export var StyledIcon = styled(Icon)(_templateObject(), function (props) {
  return "\n        cursor: pointer;\n        font-size: ".concat(props.theme.components.notification.closeFontSize, ";\n\n        & > svg {\n            position: absolute;\n            top: calc(calc(100% - ").concat(props.theme.components.notification.closeFontSize, ") / 2);\n            right: ").concat(props.theme.components.notification.closeRight, ";\n        }\n    ");
});
export var MobileStyledNotification = function MobileStyledNotification(props) {
  return css(_templateObject2(), media.max.phone(_templateObject3(), props.theme.components.notification.mobileFontSize, props.theme.components.notification.marginLeft, props.theme.components.notification.marginTop, props.theme.components.notification.marginLeft));
};
export var FixedStyledNotification = function FixedStyledNotification(props) {
  return css(_templateObject4(), MobileStyledNotification(props), props.visible ? "\n                top: 0;\n            " : '');
};
export var RelativeStyledNotification = function RelativeStyledNotification(props) {
  return css(_templateObject5(), props.visible ? "\n                max-height: 100000vh;\n            " : "\n                max-height: 0;\n                pointer-events: none;\n                padding-top: 0\n                padding-bottom: 0\n                margin: 0;\n            ");
};
export var StyledNotification = styled.div(_templateObject6(), function (props) {
  return css(_templateObject7(), props.theme.components.notification.fontSize, props.theme.components.notification.lineHeight, props.theme.components.notification.fontWeight, props.theme.components.notification.padding, props.theme.components.notification.colors[props.type].foreground, props.theme.components.notification.colors[props.type].background, props.theme.components.notification.transition, props.theme.components.notification.zIndex, props.fixed ? FixedStyledNotification(props) : RelativeStyledNotification(props), props.visible ? "\n                    top: 0;\n                    opacity: 1;\n                " : '');
});